import { IGetNewbornScreeningParams, INewbornScreeningTest } from '~/interfaces'
import { AxiosResponse, axios } from '~/modules'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchNewbornScreening = async (params: IGetNewbornScreeningParams): Promise<INewbornScreeningTest[]> => {
  const response = await axios.get(`${hstoryAPI}/patients/${params.patientId}/newborn-screening-tests`)
  const { data }: AxiosResponse<INewbornScreeningTest[]> = response
  return data
}
